<template>
  <component :is="layout">
    <!-- <router-view /> -->
  </component>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import LayoutApp from '@/layouts/LayoutApp.vue'
import LayoutGuest from '@/layouts/LayoutGuest.vue'

export default {
  components: {
    LayoutApp,
    LayoutGuest
  },
  setup() {
    const route = useRoute()

    const layout = computed(() => {
      return route.meta.layout === 'guest' ? 'LayoutGuest' : 'LayoutApp'
    })

    return { layout }
  }
}
</script>